import { Separator } from '@/components/ui/separator';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { useNavigate } from "react-router-dom";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from './ui/sheet';


function Header() {
  // State to track if the sheet is open
  const navigate = useNavigate();
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  //

  // For submenu logic
  const [activeMenu, setActiveMenu] = useState("main");
  const [subMenuItems, setSubMenuItems] = useState([]);
  const [titlePath, setTitlePath] = useState(["Menu"]);

  // Example data with sub menus
  const menuGroups = [

    {
      items: [
        { label: "About", link: "/about" },
        { label: "Membership", link: "/requestaccess" },
        { label: "How it works", link: "/howitworks" },
        { label: "Contact", link: "/contact" },
      ]
    }


  ];

  // Click handler for a main‐menu item
  const handleMainItemClick = (item) => {
    // If there's a subMenu, go deeper
    if (item.subMenu) {
      setActiveMenu("sub");
      setSubMenuItems(item.subMenu);
      setTitlePath((prev) => [...prev, item.label]);
    }
    // Otherwise, if there's a link, navigate directly
    else if (item.link) {
      navigate(item.link);
      // Also close the sheet if you want
      setIsSheetOpen(false);
    }
  };

  // If user wants to go back to main menu (or close sub)
  const handleBackToMain = () => {
    // Return to main
    setActiveMenu("main");
    setSubMenuItems([]);
    // Reset the title path
    setTitlePath(["Menu"]);
  };

  //
  return (
    <header
      className={`sticky items-top top-0 z-30 w-full p-4 grid grid-cols-[1fr_auto_1fr] bg-[rgb(var(--background))] text-[rgb(var(--foreground))] ${isSheetOpen ? 'opacity-100 pointer-events-none' : ''
        }`}
    >
      {/* Left: Menu Button */}
      <div className="flex items-start justify-start">
        <Sheet
          open={isSheetOpen}
          onOpenChange={(open) => {
            setIsSheetOpen(open);

            // If the Sheet is closing, reset to the original menu
            if (!open) {
              setActiveMenu("main");
              setTitlePath(["Menu"]);
              setSubMenuItems([]);
            }
          }}
        >
          <SheetTrigger asChild>
            {/* Menu */}
            <div className="flex items-center justify-center overflow-visible hover:opacity-60 transition duration-120">
              <img
                src="/assets/icons/menu_icon.svg"
                alt="Menu"
                className="w-7 md:w-9 p-0"
              />
            </div>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="
              rounded-xl
              inset-2
              bottom-2 right-2
              h-auto
              w-auto
              bg-[rgb(var(--card))]
              text-[rgb(var(--card-foreground))]
              flex flex-col"
          >
            <SheetHeader>
              <SheetTitle className="font-sans text-xl flex items-center">
                {titlePath.map((part, i) => {
                  const isLast = i === titlePath.length - 1;
                  const isMenu = part === "Menu" && i === 0;

                  // If it's "Menu," make it clickable to go home
                  if (isMenu && !isLast) {
                    return (
                      <button
                        key={i}
                        onClick={handleBackToMain}
                        className="text-gray-400 mr-1 hover:text-gray-600 bg-transparent px-0"
                      >
                        {part}
                        {" → "}
                      </button>
                    );
                  }
                  // If not the last, show in grey with ">" after
                  else if (!isLast) {
                    return (
                      <span key={i} className="text-[#8b8bff] mr-1">
                        {part} &gt;{" "}
                      </span>
                    );
                  }
                  // Last item is just plain text
                  else {
                    return <span key={i} className="text-xl text-[#8b8bff] mb-2">{part}</span>;
                  }

                })}
              </SheetTitle>
              <Separator className='my-4 bg-[#ddd] border-[1px] border-[#8b8bff]' />
            </SheetHeader>


            {/* MAIN MENU vs SUB MENU */}
            <div className="flex-1 overflow-y-auto">

              {activeMenu === "main" && (
                <div className="my-4">
                  {menuGroups.map((group, groupIndex) => (
                    <div key={groupIndex} className="mb-8">
                      {/* Each group is one <ul> */}
                      <ul className="space-y-4">
                        {group.items.map((item, idx) => {
                          // If item has subMenu, handle sub-menu click
                          if (item.subMenu) {
                            return (
                              <li key={idx}>
                                <button
                                  onClick={() => handleMainItemClick(item)}
                                  variant='link'
                                  className="text-sm font-sans focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black px-0 p-0"
                                >
                                  {item.label}
                                </button>
                              </li>
                            );
                          }
                          // If item has a link, go straight there
                          else if (item.link) {
                            return (
                              <li key={idx}>
                                <button
                                  onClick={() => {
                                    navigate(item.link);
                                    setIsSheetOpen(false);
                                  }}
                                  variant='link'
                                  className="text-3xl hover:text-[#6666ff] font-regular font-custom_medium focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-[#4d4dff] px-0 p-0"
                                >
                                  {item.label}
                                </button>
                              </li>
                            );
                          }
                          // Otherwise, plain label (or handle as needed)
                          return <li key={idx}>{item.label}</li>;
                        })}
                      </ul>

                      {/* Insert a <Separator> after each group except the last */}
                      {groupIndex < menuGroups.length - 1 && (
                        <Separator className="my-4" />
                      )}
                    </div>
                  ))}
                </div>
              )}



              {activeMenu === "sub" && (
                <div>
                  {/* (Optional) "Back" button or breadcrumb */}
                  {/* <button onClick={handleBackToMain}>← Back</button> */}

                  <ul className="font-sans text-sm my-4 space-y-4">
                    {subMenuItems.map((item, idx) => {
                      // If the sub‐item also has deeper subMenu, do something similar:
                      if (item.subMenu) {
                        return (
                          <li key={idx}>
                            <button
                              onClick={() => handleMainItemClick(item)}
                              variant='link'
                              className="text-sm font-sans focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black px-0 p-0"
                            >
                              {item.label}
                            </button>
                          </li>
                        );
                      }
                      // Otherwise, if there's a link
                      else if (item.link) {
                        return (
                          <li key={idx}>
                            <button
                              onClick={() => {
                                navigate(item.link);
                                setIsSheetOpen(false);
                              }}
                              variant='link'
                              className="text-sm font-sans focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black px-0 p-0"
                            >
                              {item.label}
                            </button>
                          </li>
                        );
                      }
                      // Fallback if no subMenu or link
                      return <li key={idx}>{item.label}</li>;
                    })}
                  </ul>
                </div>
              )}

            </div>

            {/* Footer: Full-width buttons at the bottom */}
            <SheetFooter className="p-0">
  <div className="w-full">
    <Button
      asChild
      onClick={() => setIsSheetOpen(false)}
      variant="default"
      className="w-full mb-1 text-sm font-sans bg-[#4d4dff] hover:bg-[#6666ff]"
    >
      <Link to="https://online.museumcircle.org" target="_self">Sign in →</Link>
    </Button>
    <Button
      asChild
      onClick={() => setIsSheetOpen(false)}
      variant="default"
      className="w-full text-sm font-sans bg-[#4d4dff] hover:bg-[#6666ff]"
    >
      <Link to="/contact">Contact →</Link>
    </Button>
  </div>
</SheetFooter>

          </SheetContent>
        </Sheet>
      </div>




      {/* Center: SVG Logo */}
      <div className="flex items-center justify-center overflow-visible">
        <Link to="/">
          <img
            src="/assets/logos/MC_Wordmark_C.svg"
            alt="Museum Circle Logo"
            className="h-20 sm:h-28 px-0"
          />
        </Link>
      </div>

      {/* Right: Account and Cart Buttons */}
      <div className="flex items-start justify-end space-x-4 focus:outline-none focus:ring-0 focus-visible:outline-none font-sans">
        {/* Right: Sign in and language */}

        <div className="flex items-center justify-center overflow-visible hover:opacity-60 transition duration-120">
          <a
          href="https://online.museumcircle.org"
          target="_self"
          >
              <img
                src="/assets/icons/account_icon.svg"
                alt="Menu"
                className="w-7 md:w-9 p-0"
              />
              </a>
            </div>

      </div>
    </header>
  );
}

export default Header;
